import { render, staticRenderFns } from "./CricketGamesCategory.vue?vue&type=template&id=3555b220&"
import script from "./CricketGamesCategory.vue?vue&type=script&lang=js&"
export * from "./CricketGamesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports